import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';

import { AppSelectors } from 'src/app/store/app/app.selectors';

@Component({
  selector: 'pos-training-mode-banner',
  templateUrl: './training-mode-banner.component.html',
  styleUrls: ['./training-mode-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TrainingModeBannerComponent {
  @ViewSelectSnapshot(AppSelectors.trainingMode) readonly trainingMode: boolean;
}
